var banner;
var i = 0;
var banner_time = document.querySelectorAll(".timer-text");

banner_time.forEach((btn) => {
  banner = btn.innerHTML;
  var countDownDate = new Date(banner).getTime();
  var timer_text = document.querySelectorAll(".timer-text-final")[i];
  var x = setInterval(function() {
    // Get Today's Date & Time
    var now = new Date().getTime();
    // Find the Distance Between Now & Countdown Date
    var distance = countDownDate - now;
    // Time Calculations for Days, Hours, Minutes & Seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24)); 
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // Display Result    
    timer_text.innerHTML = days + "d " + hours + "h "  + minutes + "m " + seconds + "s ";
    // If Countdown is Finished, Hide Timer
    if (distance < 0) {
      clearInterval(x);
      timer_text.innerHTML = "";
    }
  }, 1000);
  i++;
});